// dependencies
import { parseISO } from "date-fns";
import { Map, fromJS } from "immutable";
import moment from "moment";
import { CreateProcess } from "redux-process";

import get from "../../utils/GetNested";
import mongoIDToMoment from "../../utils/MongoIDToMoment";
import serializeObject from "../../utils/SerializeObject";
// utils
import toFixed from "../../utils/toFixed";

export const GoalsSearch = CreateProcess({
	method: "GET",
	name: "GoalsSearch",
	type: "GOALS:SEARCH",

	request: (props) => {
		const serializedObject = serializeObject(props.payload);

		return {
			url: `/api/strategy-picker/?${serializedObject}`,
			payload: props.payload,
		};
	},

	success: (props) => {
		const request = props.request.data;
		const value = fromJS(request);

		// generate a search identifier that will always return the same
		const searchID = `${value.get("title", "")}, ${value.get("assignee", "")}, ${value.get(
			"category",
			""
		)}, ${value.get("options", "")}`;

		// get the goals and make some adjustments
		const goals = props.data.goals.map((goal) => {
			const createdDate = mongoIDToMoment(goal.id);
			const { "end-date": endDate, "start-date": startDate, ...goalProps } = goal;

			return {
				...goalProps,
				createdDate,
				endDate: moment(goal["end-date"]),
				startDate: moment(goal["start-date"]),
			};
		});

		return {
			searchID,
			goals: fromJS(goals),
		};
	},
});

export const GetGoal = CreateProcess({
	method: "GET",
	name: "GetGoal",
	type: "GOALS:FETCHONE",

	request: (props) => ({
		url: `/api/goals/?id=${props.goalID}`,
	}),

	success: (response) => {
		const statusLabels = {
			done: "Done",
			active: "Active",
			deleted: "Deleted",
			archived: "Archived",
		};

		const goals = response.data.goals.map((goal) => {
			const goalDueDate = parseISO(goal.dueDate);

			return {
				id: goal.id,
				name: goal.name,
				value: goal.value,
				target: goal.target,
				progress: toFixed(goal.progress * 100, 2),
				units: goal.units,
				outlook: goal.outlook
					? {
							id: goal.outlook.id,
							name: goal.outlook.name,
							color: goal.outlook.color,
						}
					: null,
				isPublic: false,
				sharers: goal.sharers,
				isTopGoal: goal.isTopGoal,
				assignee: {
					id: goal.assignee.id,
					name: goal.assignee.name,
				},
				dueDate: goalDueDate.isValid() ? goalDueDate : null,
				status: statusLabels[goal.status] || "",
				descendantCount: goal.descendantCount,
				ancestorCount: goal.ancestorCount,
				childCount: goal.childCount,
				canUserViewGoalDetails: goal.canViewGoalDetails,
			};
		});

		return fromJS({ goal: goals[0] });
	},
});

export const getGoalOutlook = CreateProcess({
	method: "GET",
	name: "getGoalOutlook",
	type: "GOALS:OUTLOOK",

	request: (props) => {
		const colorID = get(props, ["params", "color_id"], props.color_id) || "";

		return {
			url: `/micro/v0.1/strategy-color-picker/${colorID}`,
		};
	},

	success: (response) => response.data,
});

export const getGoalOutlooks = CreateProcess({
	method: "POST",
	name: "getGoalOutlooks",
	type: "GOALS:OUTLOOK",

	request: (props) => {
		const payload = get(props, ["params", "payload"], props.payload);

		return {
			url: `/micro/v0.1/strategy-color-picker`,
			payload,
		};
	},

	success: (response) => response.data,
});

export const getGoalCategory = CreateProcess({
	method: "GET",
	name: "getGoalCategory",
	type: "GOALS:CATEGORY",

	request: (props) => {
		const categoryID = get(props, ["params", "category_id"], props.category_id) || "";
		return {
			url: `/micro/v0.1/strategy-category-picker/${categoryID}`,
		};
	},

	success: (response) => response.data,
});

export const getGoalCategories = CreateProcess({
	method: "POST",
	name: "getGoalCategories",
	type: "GOALS:CATEGORIES",

	request: (props) => {
		const payload = get(props, ["params", "payload"], props.payload);
		return {
			url: `/micro/v0.1/strategy-category-picker`,
			payload,
		};
	},

	success: (response) => response.data,
});
